import { FC, ReactElement, useState, useEffect, RefObject } from 'react'
import styled, { css, ThemeProvider } from 'styled-components'
import StoryMenu from '../StoryMenu'
import Title from '../Title'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import {
  TamediaStyles,
  MicroFrontendProps,
  tamediaColors,
} from '@ta-interaktiv/microfrontend-template-helpers'
import { useGlobalState } from '@ta-interaktiv/utils'

const defaultProperties: { [key: string]: string } = {
  module: 'title',
  titleText: 'Das ist ein Titel',
  titleSub: 'Das ist ein Untertitel',
  titleId: '0',
  menuEntries:
    '["<div><b>Punkt 1:</b> Einleitung und noch mehr Text bis die Zeile endlich irgendwann umbricht</div>", "Punkt 2", "Punkt 3", "Punkt 4", "Punkt 5", "Punkt 6", "Punkt 7", "Punkt 8", "Punkt 9", "Punkt 10", "Punkt 11", "Punkt 12", "Punkt 13", "Punkt 14"]',
  hideNumbers: 'false',
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const [elements, setElements] = useGlobalState<{[x:string]: HTMLDivElement}>('elements', {})

  const theme = {
    purpleBright: '#BA7FB7',
    purpleMain: '#A757A3',
    purpleDark: '#7A3F77',
    purpleDarker: '#512A4F',
    colorMode: colorMode,
    grayLight: '#f8f9fc',
    grayMain: '#f1f3f9',
    grayDark: '#dee3ed',
  }
  const menuEntries = JSON.parse(properties.menuEntries || '[]').map(
    (entry: string) => ({ html: entry })
  )

  const modules: { [key: string]: ReactElement } = {
    menu: (
      <StoryMenu
        elementsRefs={elements}
        elements={menuEntries}
        hideNumbers={properties.hideNumbers === 'true'}
      />
    ),
    title: (
      <Title
        text={properties.titleText}
        sub={properties.titleSub}
        id={properties.titleId}
        hideNumbers={properties.hideNumbers === 'true'}
      />
    ),
  }

  const handleTest = (e: any) => {
    const el = elements
    el[e.detail.id] = e.detail.data
    setElements(el)
  }

  useEffect(() => {
    window.addEventListener('test', handleTest)

    return () => {
      window.removeEventListener('test', handleTest)
    }
  }, [])

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>
        {properties?.module && modules[properties.module]}
        {/* properties?.module && modules['title'] */}
      </ThemeProvider>
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`
  // 🌞 all custom Light Mode variables
  --menu-background: ${tamediaColors.beige.bright3};
  --num-background: ${tamediaColors.brandblue.main};
  --num-color: #fff;
  --icon-color: ${tamediaColors.brandblue.main};
  ${({ $colorMode: colorMode }) =>
    colorMode === 'dark'
      ? css`
          // 🌚 all custom Dark Mode variables
          --menu-background: ${tamediaColors.brandblue.bright1};
          --num-background: ${tamediaColors.beige.bright1};
          --num-color: ${tamediaColors.brandblue.main};
          --icon-color: ${tamediaColors.beige.bright3};
        `
      : ''}
`
export default MainComponent
